import api from './apiClient';

// Lambda-backed admin service (no local storage). All methods are async.
const adminService = {
  // Full list
  async getListData() {
    return await api.get('/admin');
  },
  // Only non-deleted admins
  async getActiveAdmins() {
    const list = await api.get('/admin');
    return (list || []).filter((a) => !a?.isDeleted);
  },
  // By id
  async getListObjectDataById(id) {
    return await api.get(`/admin/${encodeURIComponent(id)}`);
  },
  // Create new admin (server may assign id if missing)
  async createAdmin(username, password, role = 'a') {
    const body = {
      username: String(username || ''),
      password: String(password || ''),
      role: role === 's' ? 's' : 'a',
      isDeleted: false,
    };
    return await api.post('/admin', body);
  },
  // Soft delete (set isDeleted = true)
  async softDeleteById(id) {
    await api.put(`/admin/${encodeURIComponent(id)}`, { isDeleted: true });
    return true;
  },
  // Update credentials/role for a given id (id preserved on server)
  async updateCredentialsById(id, { username, password, role } = {}) {
    const patch = {};
    if (username != null) patch.username = String(username);
    if (password != null) patch.password = String(password);
    if (role != null) patch.role = role === 's' ? 's' : 'a';
    return await api.put(`/admin/${encodeURIComponent(id)}`, patch);
  },
};

export default adminService;
